<template>
  <button class="kw-button kw-button-secondary kw-search-button" type="button" @click="$emit('click', $event)">
    <span class="kw kw-search" />
  </button>
</template>

<script>
export default {
  name: 'SearchKeywordsButton',
};
</script>

<style lang="scss" scoped>
.kw-button {
  padding: 8px 8px;
  border: 1px solid kw-color(kw-light-grey, 3);
  @include box-shadow-1;
  background-color: kw-color(kw-white, 1);
  transition: 0.2s;

  &:hover {
    border: 1px solid kw-color(kw-blue, 1);
    @include box-shadow-3;
  }
}

.kw-search {
  color: kw-color(kw-blue, 1);
  font-size: 18px;
  font-weight: 700;
}
</style>
